import { buildCsvFromRows } from '../../shared/csv-core/infra/buildCsv';
import type { SaleListRow } from './salesRepo';
import {
  formatSaleChannelLabel,
  spanishPaymentStatusLabel,
  spanishSaleStatusLabel,
  formatSaleListItemsSummary,
  formatSaleListPaymentMethods,
  formatSaleShortRefLabel,
} from '../application/salePresentation';

export function buildSalesListCsv(
  rows: SaleListRow[],
  options?: { paymentMethodNames?: Record<string, string> }
): string {
  const pmn = options?.paymentMethodNames ?? {};
  const headers = [
    'ref',
    'id',
    'fecha_iso',
    'total',
    'items',
    'cantidad_items',
    'canal',
    'medio_cobro',
    'operador',
    'estado',
    'estado_pago',
    'cobrado',
    'pendiente',
    'fiscal',
    'cae',
    'cliente_fiado',
    'cliente',
    'anulada_el',
    'motivo_anulacion',
  ];

  const dataLines = rows.map((row) => {
    const isVoided = row.status === 'voided';
    return [
      formatSaleShortRefLabel(row.id),
      row.id,
      row.createdAt,
      String(row.total),
      formatSaleListItemsSummary(row),
      String(row.itemCount ?? 0),
      formatSaleChannelLabel(row.channel),
      formatSaleListPaymentMethods(row.paymentMethodIds, pmn),
      row.cashierDisplayName ?? row.cashierUserId ?? '',
      spanishSaleStatusLabel(row.status),
      spanishPaymentStatusLabel(row.paymentStatus),
      String(row.paidAmount ?? 0),
      String(row.pendingAmount ?? 0),
      row.fiscalMode === 'non_fiscal' ? 'No fiscal' : (row.fiscalStatus || ''),
      row.invoiceCae ?? '',
      row.fiadoCustomerName ?? '',
      row.customerName ?? '',
      isVoided ? (row.voidedAt ?? '') : '',
      isVoided ? (row.voidReason ?? '') : '',
    ];
  });

  return buildCsvFromRows(headers, dataLines);
}
